import { WifiOffIcon32 } from '@repo/ui/icons'
import useOnlineDetection from '@/features/offline/hooks/useOnlineDetection'

export interface OfflineIndicatorProps {
  'data-testid': string
}

export default function OfflineIndicator({
  'data-testid': testId
}: Readonly<OfflineIndicatorProps>) {
  const isOnline = useOnlineDetection()

  if (isOnline) {
    return null
  }

  return <WifiOffIcon32 className="shrink-0" data-testid={`${testId}-icon}`} />
}
